import { apiFetch } from "@/lib/api";

/**
 * Una comuna del registro oficial: las 346 del Decreto Exento N° 1.115
 * (Diario Oficial, 21-09-2018), servidas por `GET /api/comunas`.
 */
export interface Comuna {
  /**
   * El Código Único Territorial, de 5 caracteres CON ceros a la izquierda
   * ("01101" es Iquique). Es `string` y no `number` a propósito, en los dos
   * lados: como número, Iquique pasaría a ser 1101, que no existe.
   */
  codigo: string;
  nombre: string;
  provincia: string;
  region: string;
}

export async function fetchComunas(): Promise<Comuna[]> {
  const respuesta = await apiFetch<{ data: Comuna[] }>("/api/comunas");
  return respuesta.data;
}
